import { ComponentRef } from '@angular/core';
import { TemplateContext } from '../../../../models/reportTemplate.model';
import { EditorPropertySchema, EditorRenderStrategy } from '../../sample-widgets/widget-config.helpers';
import { RiskRegisterMatrixData, RR_STYLES } from './risk-register-table-presentation.service';
import { RiskRegisterTableWidgetComponent } from './risk-register-table-widget.component';

interface ComputedRiskRegisterData extends Record<string, unknown> {
    matrix?: RiskRegisterMatrixData;
}

interface RiskRegisterContext extends TemplateContext {
    computedData?: ComputedRiskRegisterData;
}

export function configureRiskRegisterTableWidget(
    componentRef: ComponentRef<unknown>,
    context: TemplateContext
): void {
    const component = componentRef.instance as RiskRegisterTableWidgetComponent;
    const ctx = context as RiskRegisterContext;
    component.data = ctx.computedData?.matrix ?? null;
}

export const riskRegisterTableLoopTemplate = [
    '[[#if computedData.riskRegisterMatrix.hasData]]',
    '<div class="rrw-widget">',
    '[[#each computedData.riskRegisterMatrix.chunks]]',
    `<div style="${RR_STYLES.chunk}">`,
    `<table style="${RR_STYLES.table}">`,
    '<thead>',
    '<tr>',
    `<th style="${RR_STYLES.headerCell}">SEG Code</th>`,
    `<th style="${RR_STYLES.headerCell}">SEG Name</th>`,
    `<th style="${RR_STYLES.headerCell}">No of Employees</th>`,
    `<th style="${RR_STYLES.headerCell}">No of Contractors</th>`,
    `<th data-tpl-each="this.columns" style="${RR_STYLES.headerCell}">`,
    '<div>[[this.agentName]]</div>',
    `<div style="${RR_STYLES.consequence}">Consequence Rating: [[this.consequenceRating]]</div>`,
    '</th>',
    '</tr>',
    '</thead>',
    '<tbody>',
    '<tr data-tpl-each="this.rows">',
    `<td style="${RR_STYLES.fixedCell}">[[this.segCode]]</td>`,
    `<td data-tpl-style="[[this.segNameStyle]]" style="${RR_STYLES.fixedCell}">[[this.segName]]</td>`,
    `<td style="${RR_STYLES.fixedCell}">[[this.numberOfWorkers]]</td>`,
    `<td style="${RR_STYLES.fixedCell}">[[this.numberOfContractors]]</td>`,
    `<td data-tpl-each="this.cells" data-tpl-style="[[this.cellStyle]]" style="${RR_STYLES.matrixCell}">[[this.statText]]</td>`,
    '</tr>',
    '</tbody>',
    '</table>',
    '</div>',
    '[[/each]]',
    `<div style="${RR_STYLES.legend}">`,
    '[[#each computedData.riskRegisterMatrix.legendItems]]',
    `<span style="${RR_STYLES.legendItem}">`,
    `<span data-tpl-style="[[this.swatchStyle]]" style="${RR_STYLES.swatch}background:#cccccc;">&#8203;</span>`,
    '<span>[[this.label]]</span>',
    '</span>',
    '[[/each]]',
    '</div>',
    `<div style="${RR_STYLES.footer}">Report generated using SEGs, Agents, and Statistics</div>`,
    '</div>',
    '[[/if]]'
].join('\n');

export const riskRegisterTableLoopScopes: { loopExpr: string; label: string; fields: string[] }[] = [
    { loopExpr: 'computedData.riskRegisterMatrix.chunks', label: 'Per Table', fields: [] },
    { loopExpr: 'this.columns', label: 'Per Agent Column', fields: ['agentName', 'consequenceRating'] },
    { loopExpr: 'this.rows', label: 'Per SEG Row', fields: ['segCode', 'segName', 'numberOfWorkers', 'numberOfContractors'] },
    { loopExpr: 'this.cells', label: 'Per Cell', fields: ['statText'] },
    { loopExpr: 'computedData.riskRegisterMatrix.legendItems', label: 'Per Rating', fields: ['label'] }
];

export const riskRegisterTableEditorPropertySchema: EditorPropertySchema = {
    renderStrategy: EditorRenderStrategy.ReadOnly,
    propertySchema: []
};
